import type { ButtonHTMLAttributes, JSX } from "react";

import { cn } from "@/shared/lib/cn";

/**
 * The gradient "primary" button the design system uses across the app (see the
 * inventory toolbar). One per view (CLAUDE.md Rule 12). Token-driven; no raw hex.
 */
export function PrimaryButton({
  className,
  children,
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement>): JSX.Element {
  return (
    <button
      className={cn(
        "inline-flex h-9 items-center gap-1.5 rounded-[var(--control-r)] px-4 text-[13.5px] font-bold text-white transition hover:-translate-y-px disabled:translate-y-0 disabled:opacity-50",
        className,
      )}
      style={{
        background: "var(--grad-primary-btn)",
        boxShadow:
          "0 1px 2px rgba(15,98,254,.5),0 6px 16px -4px rgba(15,98,254,.5),inset 0 1px 0 rgba(255,255,255,.22)",
      }}
      {...props}
    >
      {children}
    </button>
  );
}

/** Bordered secondary/ghost button matching the app shell controls. */
export function SecondaryButton({
  className,
  children,
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement>): JSX.Element {
  return (
    <button
      className={cn(
        "inline-flex h-9 items-center gap-1.5 rounded-[var(--control-r)] border border-[var(--premium-border-strong)] bg-white px-4 text-[13.5px] font-semibold text-[var(--text-secondary)] shadow-[var(--sh-xs)] transition hover:bg-[var(--canvas)] disabled:opacity-50",
        className,
      )}
      {...props}
    >
      {children}
    </button>
  );
}
